import * as EXIF from 'exif-js';

export function ExifService() {
    return {
        getData: EXIF.getData,
        getTag: EXIF.getTag,
    };
}
